import ProjectView from "backbone/projects/views/project_view.js"

export default class ProjectsCollectionView extends Backbone.View
  initialize: ->
    @subviews = []
    if @options.collection
      @collection = @options.collection
    @parentViewState = @options.viewState
    @listenTo(@collection, "add", @prependNewProject)
    @listenTo(@collection, "remove", @render)
    @listenTo(@collection, "render", @render)

  fetch: ->
    @collection.fetch
      success: (collection, resp) ->
        collection.reset resp.projects, silent: true
        hasNextPage = resp.total_count > collection.size()
        collection.trigger("render", totalCount: resp.total_count, hasNextPage: hasNextPage)
      error: ->
        contently.flash.alert "There was a problem loading your projects"

    this

  render: ->
    @removeSubviews()
    @subviews = []

    @$el.empty().removeClass("loading")
    for project in @collection.models
      @appendProject(project)

    if @editFirstProject
      @subviews[0].beginEdit()
      @editFirstProject = false

    this

  prependNewProject: (project) ->
    projectView = @projectView(project)
    @subviews.unshift(projectView)
    @$el.prepend(projectView.render().el)
    if project.persisted()
      @editFirstProject = true
    else
      projectView.create()

  appendProject: (project) ->
    projectView = @projectView(project)
    @subviews.push(projectView)
    @$el.append(projectView.render().el)

  projectView: (project) ->
    new ProjectView
      project: project
      onRemove: @onRemove
      removeProject: @removeProject
      collection: @collection
      skills: @options.skills
      storyFormats: @options.storyFormats
      topics: @options.topics
      parentViewState: @parentViewState

  removeSubviews: ->
    for subview in @subviews
      subview.remove()

  removeProject: (project) =>
    @collection.remove(project)

  onRemove: (project) =>
    project.destroy
      success: =>
        @removeProject(project)
      error: =>
        @render()
        contently.flash.alert("Sorry, but an error occurred while trying to delete your project.")

  remove: ->
    @removeSubviews()
    @stopListening()
    super()

  allSkillInputsValid: ->
    @subviews.filter((view) ->
      view.validateSkills() == false
    ).length == 0

  allTopicInputsValid: ->
    @subviews.filter((view) ->
      view.validateTopics() == false
    ).length == 0

  saveProjectSkills: ->
    for projectView in @subviews
      projectView.addSkillsOrTopicView.submitAddSkillsForm()

  saveProjectTopics: ->
    for projectView in @subviews
      projectView.addSkillsOrTopicView.submitAddTopicsForm()

  saveAndFinishLater: ->
    for projectView in @subviews
      projectView.addSkillsOrTopicView.submitAndFinishLater()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/projects_collection_view.js.coffee